@if (duplicates && duplicates.length > 0 && !hideMessage) {
  <mat-card appearance="outlined" class="container-card">
    <mat-card-header><mat-icon color="warn">error</mat-icon></mat-card-header>
    <br/>
    <mat-card-content>
      <b>{{ message }}</b>
      <hr/>
      <table mat-table [dataSource]="duplicates">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">{{element.name}}</td>
        </ng-container>
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef class="action-col"></th>
          <td mat-cell *matCellDef="let element" class="action-col">
            <button mat-icon-button aria-label="View" [routerLink]="element.url">
              <mat-icon>exit_to_app</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-row *matRowDef="let row; columns: ['name', 'action'];"></tr>
      </table>
      <hr/>
      <mat-card-actions [align]="'end'">
        <button (click)="hideMessage = true" mat-button>DISMISS</button>
      </mat-card-actions>
    </mat-card-content>
  </mat-card>
}
